import script from "./accountInfoAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./accountInfoAlert.vue?vue&type=script&setup=true&lang=js"

import "./accountInfoAlert.vue?vue&type=style&index=0&id=f0c444ae&lang=scss&scoped=true"

import exportComponent from "/Users/zhuweiyun/Desktop/zwy/vue3-天空之城/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f0c444ae"]])

export default __exports__